import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { isMaisterchef, isMaisterchefGermanTheme } from '../utils/branding';

const LanguageFooter = () => {
    const { language } = useLanguage();
    const deLegalBase = isMaisterchef ? 'https://maisterchef.com' : 'https://souschaif.com';

    // Only show footer for Belgian languages, German and Portuguese (removed Bahrain languages)
    if (language !== 'befr' && language !== 'benl' && language !== 'be-fr' && language !== 'be-nl' && language !== 'deutsch' && language !== 'portuguese') {
        return null;
    }

    return (
        <footer className={`fixed bottom-0 left-0 right-0 bg-white py-2 px-4 text-center text-sm border-t border-gray-200 z-40 ${isMaisterchefGermanTheme(language) ? 'mc-de-legal' : ''}`}>
            {(language === 'befr' || language === 'be-fr') && (
                <div className="flex justify-center space-x-4">
                    <a
                        target="_blank"
                        href="https://souschaif.com/frbe/conditions-generales-2/"
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Conditions générales (CGV)
                    </a>
                    <a
                        target="_blank"
                        href="https://souschaif.com/frbe/imprimer-2/"
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Imprimer
                    </a>
                </div>
            )}

            {(language === 'benl' || language === 'be-nl') && (
                <div className="flex justify-center space-x-4">
                    <a
                        target="_blank"
                        href="http://souschaif.com/nl/algemene-voorwaarden/"
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Algemene Voorwaarden
                    </a>
                    <a
                        target="_blank"
                        href="https://souschaif.com/nl/imprint/"
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Imprint
                    </a>
                </div>
            )}

            {language === 'portuguese' && (
                <div className="flex justify-center space-x-4">
                    <a
                        target="_blank"
                        href="https://souschaif.com/pt/termos-e-condicoes/"
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Termos e Condições
                    </a>
                </div>
            )}

            {language === 'deutsch' && (
                <div className="flex justify-center space-x-4 flex-wrap gap-y-1">
                    <a
                        target="_blank"
                        href={`${deLegalBase}/dede/hilfe-faq/`}
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Hilfe
                    </a>
                    <a
                        target="_blank"
                        href={`${deLegalBase}/dede/allgemeine-geschaftsbedingungen-3/`}
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        AGB
                    </a>
                    <a
                        target="_blank"
                        href={`${deLegalBase}/dede/impressum-4/`}
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Impressum
                    </a>
                    <a
                        target="_blank"
                        href={`${deLegalBase}/dede/datenschutzerklarung/`}
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Datenschutz
                    </a>
                    <a
                        target="_blank"
                        href={isMaisterchef
                            ? "https://my.kanzaroo.com/register.xhtml?utm_source=chatgpt.com"
                            : "https://www.mbe4.de/endkundenportal/"}
                        className="text-gray-600 hover:text-gray-900"
                        rel="noopener noreferrer"
                    >
                        Kündigung
                    </a>
                </div>
            )}
        </footer>
    );
};

export default LanguageFooter;
